import { createRouter, createWebHashHistory } from "vue-router"
import BasicLayout from "@/views/layouts/BasicLayout"

export const routes = [
	{
		path: "/",
		name: "index",
		meta: { title: "login" },
		hidemenu: true,
		redirect: "/login",
		children: [
			{
				path: "/login",
				name: "login",
				hidemenu: true,
				meta: { title: "login", authentication_skip: true },
				component: () => import("@/views/login/Login"),
			},
			{
				path: "/register",
				name: "register",
				hidemenu: true,
				meta: { title: "register", authentication_skip: true },
				component: () => import("@/views/login/Register"),
			},
			{
				path: "/resetuser",
				name: "resetuser",
				hidemenu: true,
				meta: { title: "resetuser", authentication_skip: true },
				component: () => import("@/views/login/ResetUser"),
			},
			{
				path: "/openpage",
				name: "openpage",
				hidemenu: true,
				meta: { title: "resetuser", authentication_skip: true },
				component: () => import("@/views/open/OpenPage"),
			},
			{
				path: "/test",
				name: "test",
				hidemenu: true,
				meta: { title: "test", authentication_skip: true },
				component: () => import("@/views/test/test"),
			},
		],
	},
	{
		path: "/home",
		name: "home",
		meta: { title: "Home" },
		hidemenu: false,
		component: BasicLayout,
		redirect: "/show/shows-board",
		children: [
			{
				path: "/show",
				name: "show",
				meta: { title: "Show", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/show/Show"),
				redirect: "/show",
				children: [
					{
						path: "/show/shows-board",
						name: "shows board",
						meta: { title: "Shows Board", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/show/show_board.vue"),
					},
					{
						path: "/show/show-details",
						name: "show details",
						meta: { title: "Show Details", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/show/show-center.vue"),
					},
				],
			},
			{
				path: "/turnover",
				name: "turnover",
				meta: { title: "Turnover", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/turnover/Turnover"),
				redirect: "/turnover/turnover-board",
				children: [
					{
						path: "/turnover/turnovers-board",
						name: "turnovers board",
						meta: { title: "Turnovers Board", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/turnover/turnovers/turnovers-info.vue"),
					},
					{
						path: "/turnover/turnover-details",
						name: "turnover details",
						meta: { title: "Turnover Details", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/turnover/turnover-center.vue"),
					}
				],
			},
			{
				path: "/bid",
				name: "bid",
				meta: { title: "Bids", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/turnover/Bid"),
				redirect: "/bid/bid-board",
				children: [
					{
						path: "/bid/bid-board",
						name: "bid board",
						meta: { title: "Bids Board", role: [1] },
						hidemenu: false,
						component: () => import("@/views/bids/bids-info.vue"),
					},
					{
						path: "/bid/bid-details",
						name: "bid details",
						meta: { title: "Bid Details", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/bids/bids-detail.vue"),
					}
				],
			},

			{
				path: "/stuffing",
				name: "stuffing",
				meta: { title: "Staffing", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/stuffing/Stuffing"),
				redirect: "/dept-overview",
				children: [
					{
						path: "/stuffing-board",
						name: "stuffing board",
						meta: { title: "Staffing Board", role: [1] },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/stuffing_detail.vue"),
					},
					{
						path: "/dept-overview",
						name: "dept_overview",
						meta: { title: "Dept Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/dept_overview/DeptOverView"),
					},
					{
						path: "/studio-crew-overview",
						name: "studio-crew-overview",
						meta: { title: "Studio Crew Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/production/overview/prod-overview"),
					},
					{
						path: "/resource-overview",
						name: "resource-overview",
						meta: { title: "Resource Overview", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/stuffing/resource_overview/ResourceOverview"),
					},
				],
			},
			// {
			// 	path: "/production",
			// 	name: "production",
			// 	meta: { title: "production", role: [1, 2, 3] },
			// 	hidemenu: false,
			// 	component: () => import("@/views/production/production"),
			// 	children: [
			// 		{
			// 			path: "/prod-test",
			// 			name: "prod-test",
			// 			meta: { title: "Test", role: [1, 2, 3] },
			// 			hidemenu: false,
			// 			component: () => import("@/views/widgets/generic-form.vue"),
			// 		}
			// 	],
			// },
			{
				path: "/data-center",
				name: "data_center",
				meta: { title: "Data Center", role: [1, 3] },
				hidemenu: false,
				component: () => import("@/views/data_center/DataCenter"),
				children: [
					{
						path: "/timelogs",
						name: "timelogs",
						meta: { title: "Time Logs", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/time_logs/TimeLogs"),
					},
					{
						path: "/tasks",
						name: "task",
						meta: { title: "Tasks", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/task/datacenter_tasks.vue"),
					},
					{
						path: "/shot",
						name: "shot",
						meta: { title: "Shots", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/shot/datacenter_shots.vue"),
					},
					{
						path: "/user",
						name: "user",
						meta: { title: "Users", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/user/User"),
					},
					{
						path: "/project",
						name: "project",
						meta: { title: "Projects", role: [1, 3] },
						hidemenu: false,
						component: () => import("@/views/data_center/project/Project"),
					},
				],
			},
			{
				path: "/purchaser-showcase",
				name: "purchaser_showcase",
				meta: { title: "Base Showcase", authentication_skip: true },
				hidemenu: false,
				component: () => import("@/views/purchaser_showcase/PurchaserShowcase"),
				children: [
					{
						path: "/reels-video",
						name: "reels-video",
						meta: { title: "Reels", authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/Reels"),
					},
					{
						path: "/demo-video",
						name: "demo_video",
						meta: { title: "ShowTracker Demo", authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/DemoVideo"),
					},
					{
						path: "/bts-video",
						name: "bts_video",
						meta: { title: "Base BTS", authentication_skip: true },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/BaseBTS"),
					},
					{
						path: "/video-manager",
						name: "video_manager",
						meta: { title: "Video Management", authentication_skip: false, role: [1, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/purchaser_showcase/demo_video/VideoManager"),
					},
				],
			},
			{
				path: "/person-info",
				name: "person_info",
				meta: { title: "Your Account", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/personal_info/PersonalInfo"),
				children: [
					{
						path: "/service-hours",
						name: "service_hours",
						meta: { title: "Service Hours", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import(
								"@/views/show_finance_tracker/service_hours/service_hours"
								),
					},
					{
						path: "/monthly-account-summary",
						name: "monthly_account_summary",
						meta: { title: "Account Summary", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import(
								"@/views/personal_info/monthly_account_summary/MonthlyAccountSummary"
								),
					},
					{
						path: "/my-transactions",
						name: "my_transactions",
						meta: { title: "Transactions History", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/my_transactions/MyTransactions"),
					},
					{
						path: "/deposit-info",
						name: "deposit-info",
						meta: { title: "Bank Deposit Detail", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/deposit_info/DepositInfo"),
					},
					{
						path: "/change-password",
						name: "change_password",
						meta: { title: "Change Password", role: [1, 2, 3] },
						hidemenu: false,
						component: () =>
							import("@/views/personal_info/change_password/ChangePassword"),
					}
				],
			},
			{
				path: "/admin",
				name: "admin",
				meta: { title: "Admin", role: [1, 2, 3] },
				hidemenu: false,
				component: () => import("@/views/admin/Admin"),
				children: [
					// {
					// 	path: "/tttt",
					// 	name: "tttt",
					// 	meta: { title: "Test Transaction", role: [1] },
					// 	hidemenu: false,
					// 	component: () =>
					// 		import("@/views/widgets/generic-batch-uploader.vue"),
					// },
					{
						path: "/add-transaction-new",
						name: "add_transaction_new",
						meta: { title: "Add Transaction", role: [1] },
						hidemenu: false,
						component: () =>
							import("@/views/admin/add_transaction/AddTransaction_New"),
					},
					{
						path: "/admin-transactions",
						name: "admin_transactions",
						meta: { title: "Admin Transactions", role: [1] },
						hidemenu: false,
						component: () =>
							import("@/views/admin/ecom_transactions/EcomTransactions"),
					},
					{
						path: "/control-users",
						name: "control_users",
						meta: { title: "Users Purchase", role: [1] },
						hidemenu: false,
						component: () => import("@/views/admin/control_users/ControlUsers"),
					},
					{
						path: "/users-info",
						name: "users-info",
						meta: { title: "Users Information", role: [1] },
						hidemenu: false,
						component: () => import("@/views/admin/users_info/UsersInfo"),
					},
					{
						path: "/show-logs",
						name: "show_logs",
						meta: { title: "Usage Logs", role: [1] },
						hidemenu: false,
						component: () => import("@/views/user/usage-logs"),
					},
					{
						path: "/permission-manager",
						name: "permission-manager",
						meta: { title: "Permission", role: [1] },
						hidemenu: false,
						component: () => import("@/views/user/permission-management"),
					},
					{
						path: "/contact-us",
						name: "contact_us",
						meta: { title: "Contact Us", role: [1, 2, 3] },
						hidemenu: false,
						component: () => import("@/views/admin/contact_us/ContactUs"),
					},
				],
			},
			{
				path: "/import-data",
				name: "import_data",
				meta: { title: "Import Data", role: [1] },
				hidemenu: false,
				component: () => import("@/views/import_data/ImportData"),
				children: [
					{
						path: "/import",
						name: "Import",
						meta: { title: "Import", role: [1] },
						hidemenu: false,
						component: () => import("@/views/import_data/import/import"),
					},
				],
			},
		],
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
})

export default router
